<script lang="ts">
import { ref, watch } from 'vue';

type Props = {
  size?: number;
  borderSize?: number;
  color?: string;
  isLoaded?: boolean;
};
</script>

<script setup lang="ts">
const props = defineProps<Props>();

const formattedSize = ref(Number(props.size));

watch(
  () => props.size,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      formattedSize.value = Number(props.size);
    }
  },
);
</script>

<template>
  <div
    v-if="!props.isLoaded"
    :class="$style.loader"
    :style="{
      height: size ? `${formattedSize}px` : undefined,
      width: size ? `${formattedSize}px` : undefined,
      color,
      borderWidth: borderSize,
    }"
  ></div>
</template>

<style module lang="scss">
@forward './Loading.scss';
</style>
